<template>
<!-- 	<div class="content">
		<div class='wallpaper'>
			<h1 class="title">
				<p>联系我们</p>
				<p class='title-line'></p>	
			</h1>
			<div class='map-box'>
				<div class='map'>
					<el-amap :vid="'amap-vue'" :center="mapCenter" :zoom="5" :plugin="plugin">
						<el-amap-marker v-for="marker in markers" :position="marker.position" :events="marker.events" :visible="marker.visible" :draggable="marker.draggable"></el-amap-marker>
						<el-amap-info-window v-for="window in windows" :position="window.position" :content="window.content" :open="window.open" :events="makerEvents"></el-amap-info-window>
					</el-amap>
				</div>
				<ul>
					<li id='markIcon1'>
						<h3>北京总部</h3>
						<p class='location'>北京市朝阳区慧忠里103号洛克</p>
						<p>时代中心A座703室</p>
					</li>
					<li id='markIcon2'>
						<h3>上海总部</h3>
						<p class='location'>上海市徐汇区田林路140号越界</p>
						<p>创意园16号楼东2楼201室</p>
					</li>
					<li>
						<h3>商务合作</h3>
						<p class='tel'>4001-556-256(周一至周五)</p>
						<p class='email'>cooperate@la-feng.com</p>
					</li>
				</ul>
			</div>
		</div>

	</div> -->
	<v-wall :backImg='bgImg'>
		<p slot='title'>联系我们</p>
		<div class='box'>
			<div class='map'>
				<el-amap :vid="'amap-vue'" :center="mapCenter" :zoom="5" :plugin="plugin">
					<el-amap-marker v-for="marker in markers" :key="marker.visible" :position="marker.position" :events="marker.events" :visible="marker.visible" :draggable="marker.draggable"></el-amap-marker>
					<el-amap-info-window v-for="window in windows" :key="window.visible" :position="window.position" :content="window.content" :open="window.open" :events="makerEvents"></el-amap-info-window>
				</el-amap>
			</div>
			<ul>
				<li id='markIcon1'>
					<h3>北京总部</h3>
					<p class='location'>北京市朝阳区慧忠里103号洛克</p>
					<p>时代中心A座703室</p>
				</li>
				<li id='markIcon2'>
					<h3>上海总部</h3>
					<p class='location'>上海市徐汇区田林路140号越界</p>
					<p>创意园16号楼东2楼201室</p>
				</li>
				<li>
					<h3>商务合作</h3>
					<p class='tel'>4001-556-256(周一至周五)</p>
					<p class='email'>cooperate@la-feng.com</p>
				</li>
			</ul>
		</div>
	</v-wall>
</template>

<script>
  import backImg from '../../assets/images/img_bg_01.jpg'
  export default {
    data () {
      return {
        bgImg: backImg,
        clientHeight: '',
        clientWidth: '',
        markers: [{
          position: [116.40636, 40.001949],
          events: {
            click: () => {
              this.windowPosition = [116.40636, 40.101949]
              this.windows[0].position = this.windowPosition
              this.windows[0].content = '北京总部'
              document.getElementById('markIcon1').scrollIntoView()
            }
          },
          visible: true,
          draggable: false
        }, {
          position: [121.41192200, 31.17057600],
          events: {
            click: this.makerEvents
          },
          visible: true,
          draggable: false
        }],
        mapCenter: [113.666419, 34.753963],
        windowPosition: [116.40636, 40.001949],
        windows: [{
          position: this.windowPosition,
          content: '北京总部',
          open: true
        }],
        plugin: ['ToolBar', {
          pName: 'Scale',
          defaultType: 0,
          events: {
            init (o) {
              console.log(o)
            }
          }
        }]
      }
    },
    methods: {
      makerEvents () {
        this.windowPosition = [121.41192200, 31.17057600]
        this.windows[0].position = this.windowPosition
        this.windows[0].content = '上海总部'
        document.getElementById('markIcon2').scrollIntoView()
      }
    },
    mounted () {
      const _this = this
      window.onresize = function () {
        // console.log(this.clientWidth)
        _this.clientHeight = `${document.documentElement.clientHeight}px`
        _this.clientWidth = `${document.body.offsetWidth}px`
      }
      this.windows[0].position = this.windowPosition
    },
    updated () {

    }
  }
</script>

<style lang='scss' scoped>
    @import '../../assets/style/veriable.scss';

	.box {
		.map {
			width: 100%;
			height: 450px;
		}
		ul {
			height: 40%;
			display: flex;
			flex-flow: row;
			justify-content: space-between;
			align-items: center;
			padding: 60px 80px;
			li {
				text-align: left;	
				h3 {
					padding-left: 34px;
					font-size: 24px;
					color: #000000;
					line-height: 34px;
					margin-bottom: 23px;
					font-weight: 500;
				}
				p {
					padding-left: 34px;
					font-size: 16px;
					color: #7F7F7F;
					line-height: 30px;
					&.location {
						background: url(../../assets/images/ic_address.png) no-repeat left;
					}
					&.tel {
						background: url(../../assets/images/ic_phone.png) no-repeat left;
					}
					&.email {
						background: url(../../assets/images/ic_mail.png) no-repeat left;
					}
				}
			}
		}
	}

</style>



// WEBPACK FOOTER //
// Contact.vue?595202b6